import { ComboBox } from "@progress/kendo-react-dropdowns";
import {
  galSessionData,
  selectedFieldName as gallerySelectedFieldName,
} from "../../Common/GalleryConstructor/GalleryConstructorSignals";
import { selectedFieldName, templateData } from "../../Template/NewTemplateSignals";
import {
  columnsConstructorSessionData,
  selectedColumnId,
} from "../ColumnsConstructor/ColumnsConstructorSignals";

export const listFieldNames = () => {
  if (!templateData.value) return [];

  let galleryFieldNames = [];
  let listFieldNames = [];
  let columnFieldNames = [];

  columnsConstructorSessionData.value.forEach(({ columnName, columnType }) => {
    if (columnType === "List") columnFieldNames.push(columnName);
  });

  galSessionData.value.forEach(({ fieldName, fieldType }) => {
    if (fieldType === "List" && fieldName?.length > 0) galleryFieldNames.push(fieldName);
  });

  templateData.value.sections.forEach((section) => {
    section.fields.forEach((field) => {
      if (field.fieldType === "List" || field.fieldType === "BusinessUnit")
        listFieldNames.push(field.fieldName);
    });
  });

  if (galleryFieldNames.length > 0) {
    return [
      ...listFieldNames,
      galleryFieldNames.filter((fieldName) => fieldName !== gallerySelectedFieldName.value),
    ];
  }

  if (columnFieldNames.length > 0)
    return [
      ...listFieldNames,
      columnFieldNames.filter(
        (fieldName) =>
          fieldName !== columnsConstructorSessionData.value[selectedColumnId.value].columnName
      ),
    ];

  return listFieldNames.filter((fieldName) => fieldName !== selectedFieldName.value);
};

export const ParentFieldNameProperty = {
  propertyName: "ParentFieldName",
  propertyDisplay: "Parent Field Name",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <ComboBox
        data={listFieldNames()}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName]}
      />
    );
  },
};
